import type { ComputedRef, InjectionKey } from 'vue';
import { inject } from 'vue';

export type BoostStoreStep = 'how-it-works' | 'configuration' | 'breakdown' | 'enter-email' | 'contribute';

export interface BoostStoreModalContext {
  goToStep: (step: BoostStoreStep) => void;
  close: () => void;
  storeId: ComputedRef<string>;
}

export const boostStoreModalKey: InjectionKey<BoostStoreModalContext> = Symbol('boostStoreModal');

export const useBoostStoreModal = () => {
  const context = inject(boostStoreModalKey);
  if (!context) throw new Error('useBoostStoreModal must be used within BoostStoreModal');
  return context;
};
